import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Layout from '../../../Layout/index';
import Commerce from './Commerce';
import Finance from './Finance';
import Revenue from '../../../Dashboards/revenue';
import AppDashboard from '../../../Dashboards/App/index';
import BookingDashboard from '../../../Dashboards/Booking/index';
import FitnessDashboard from '../../../Dashboards/Fitness/index';
import UI from './UI';
import Mail from '../../../Mail/index';
import Chat from '../../../Chat/index';
import Todo from '../../../Todo/index';
import Forms from './Forms';
import Tables from './Tables';
import Charts from './Charts';
import Maps from './Maps';
import Account from './Account';
import ECommerce from './ECommerce';
import DefaultPages from './DefaultPages';
import Documentation from './Documentation';
import CompareMonth from '../../../Dashboards/CompareMonth';
import SalesCategoryByDay from '../../../Dashboards/SalesCategoryByDay';
import SalesBreakdown from '../../../Dashboards/SalesBreakdown';
import SalesByRegion from '../../../Dashboards/SalesByRegion';
import AOV from '../../../Dashboards/AOV/index';
import CategorySales from '../../../Dashboards/revenue/CategorySales';
import CategorySalesByYear from '../../../Dashboards/revenue/CategorySalesByYear';
import Customer from '../../../Dashboards/Customer/index';
import Order from '../../../Dashboards/Order/index';
import SubscribersByCategory from '../../../Dashboards/SubscribersByCategory/index';
import Profit from '../../../Dashboards/revenue/profit';
import MonthlySubscription from '../../../Dashboards/revenue/monthlySubscription';
import RevenueFromSubscription from '../../../Dashboards/revenue/revenueFromSubscription';
import PromotionByRevenue from '../../../Dashboards/PromotionByRevenue';
import MonthEndInventory from '../../../Dashboards/MonthEndInventory';
import InventoryFBAForecast from '../../../Dashboards/inventory/inventoryFBAForecast';
import AdvBudgetPerformance from '../../../Dashboards/advertisment/advBudgetPerformance';
import AdvSales from '../../../Dashboards/advertisment/AdvSales';
import ErrorPage from '../../../Dashboards/ErrorPage/index';
import NewReturnCustomer from '../../../Dashboards/reports/newReturnCustomer';
import AdvProducts from '../../../Dashboards/advertisment/AdvProducts';
import AdvKeywords from '../../../Dashboards/advertisment/AdvKeywords';
import AdvCampaign from '../../../Dashboards/advertisment/advCampaigns';
import Subscribers from '../../../Dashboards/Subscription/Subscribers';
import PageTrafficWithConversion from '../../../Dashboards/reports/PageTrafficWithConversion';
import Dashboard from '../../../Dashboards/dashboard';
import RepurchaseRate from '../../../Dashboards/reports/RepuchaseRate';
import BestTimes from '../../../Dashboards/reports/bestTimes';
import BasketAnalysis from '../../../Dashboards/reports/BasketAnalysis';
import LifeTimeValue from '../../../Dashboards/revenue/LifeTimeValue';
import ResizableTable from '../../../Tables/ResizableTable';
import WholesaleCustomer from '../../../Dashboards/Wholesale/Customer';
import WholesaleOrder from '../../../Dashboards/Wholesale/Orders'
import RevenueFromCustomer from '../../../Dashboards/revenue/Customer'
import KoreaRevenue from '../../../Dashboards/Korea/Revenue'
import KoreaRevenueByCustomer from '../../../Dashboards/Korea/RevenueByCustomer'
import UploadProduct from '../../../Dashboards/UploadProductExcel'
import UploadOrder from '../../../Dashboards/UploadOrderExcel'
import Sales from '../../../Dashboards/POS/Sales'
import SalesByProduct from '../../../Dashboards/POS/SalesByProduct'
import POSExcelImport from '../../../Dashboards/POS/UploadExcel'
import POSDetail from '../../../Dashboards/POS/POSDetail'
import SalesBreakdownByProduct from '../../../Dashboards/POS/SalesBreakdownByProduct';
import Query from '../../../Dashboards/Query';
import SessionByRefferer from '../../../Dashboards/Shopify/SessionByRefferer';
import SalesByRefferer from '../../../Dashboards/Shopify/SalesByRefferer';
import SalesByChannel from '../../../Dashboards/Shopify/SalesByChannel';
import VirtualBundleSales from '../../../Dashboards/reports/VirtualBundleSales';
import VirtualBundleSalesUploadDetails from '../../../Dashboards/reports/VirtualBundleSalesUploadDetails';
import UploadVirtualBundleSalesExcel from '../../../Dashboards/reports/UploadVirtualBundleSalesExcel';
import Promotion from '../../../Dashboards/Promotions';
import CustomerTransition from '../../../Dashboards/reports/CustomerTransition'
import DataIngestionBatchStatus from '../../../Dashboards/DataIngestionBatchStatus'
import SearchPositionTracker from '../../../Dashboards/reports/SearchPositionTracker';
import UploadSearchPositionTracker from '../../../Dashboards/reports/UploadSearchPositionTracker';
import FullfillmentShipment from '../../../Dashboards/FullfillmentShipment';
import PerformanceBySKU from '../../../Dashboards/PerformanceBySKU';
import ReturnRefund from '../../../Dashboards/ReturnRefund';
import Tax from '../../../Dashboards/reports/Tax';
import UploadSubscriberExcel from '../../../Dashboards/UploadSubscriberExcel';

export default () => {
  const navigate = useNavigate();
  const warningTimer = 1140000;
  const timeOutNow = 60000;
  let warningTimerID = null;
  let timeoutTimerID = null;

  // Logout the user
  const idleTimeout = () => {
    localStorage.clear();
    navigate('/login');
  };

  const warningInactive = () => {
    clearTimeout(warningTimerID);
    timeoutTimerID = setTimeout(idleTimeout, timeOutNow);
  };

  const startTimer = () => {
    // Don't start timer on login/landing pages
    const currentPath = window.location.pathname;
    if (currentPath === '/login' || currentPath === '/') {
      return;
    }
    warningTimerID = setTimeout(warningInactive, warningTimer);
  };

  const resetTimer = () => {
    clearTimeout(timeoutTimerID);
    clearTimeout(warningTimerID);
    startTimer();
  };

  useEffect(() => {
    // Only start timer if not on login/landing pages
    const currentPath = window.location.pathname;
    if (currentPath !== '/login' && currentPath !== '/') {
      startTimer();
      
      document.addEventListener("mousemove", resetTimer, false);
      document.addEventListener("mousedown", resetTimer, false);
      document.addEventListener("keypress", resetTimer, false);
      document.addEventListener("touchmove", resetTimer, false);
      document.addEventListener("scroll", resetTimer, false);
    }

    return () => {
      clearTimeout(timeoutTimerID);
      clearTimeout(warningTimerID);
      
      document.removeEventListener("mousemove", resetTimer);
      document.removeEventListener("mousedown", resetTimer);
      document.removeEventListener("keypress", resetTimer);
      document.removeEventListener("touchmove", resetTimer);
      document.removeEventListener("scroll", resetTimer);
    };
  }, []);

  return (
    <div>
      <Layout />
      <div className="container__wrap">
        <Routes>
          <Route path="/e_commerce_dashboard" element={<Commerce />} />
          <Route path="/products" element={<ResizableTable />} />
          <Route path="/amazon/revenue" element={<Revenue vendor="amazon" />} />
          <Route path="/shopify/revenue" element={<Revenue vendor="shopify" />} />
          <Route path="/wholesale/revenue" element={<Revenue vendor="wholesale" />} />
          <Route path="/ebay/revenue" element={<Revenue vendor="ebay" />} />
          <Route path="/amazon/compare/month" element={<CompareMonth vendor="amazon" />} />
          <Route path="/shopify/compare/month" element={<CompareMonth vendor="shopify" />} />
          <Route path="/amazon/sales/category-by-month" element={<CategorySales vendor="amazon" />} />
          <Route path="/shopify/sales/category-by-month" element={<CategorySales vendor="shopify" />} />
          <Route path="/wholesale/sales/category-by-month" element={<CategorySales vendor="wholesale" />} />
          <Route path="/amazon/sales/category-by-year" element={<CategorySalesByYear vendor="amazon" />} />
          <Route path="/shopify/sales/category-by-year" element={<CategorySalesByYear vendor="shopify" />} />
          <Route path="/wholesale/sales/category-by-year" element={<CategorySalesByYear
            vendor="wholesale" />} />
          <Route path="/amazon/sales/category-by-day" element={<SalesCategoryByDay vendor="amazon" />} />
          <Route path="/shopify/sales/category-by-day" element={<SalesCategoryByDay vendor="shopify" />} />
          <Route path="/wholesale/sales/category-by-day" element={<SalesCategoryByDay vendor="wholesale" />} />
          <Route path="/ebay/sales/category-by-day" element={<SalesCategoryByDay vendor="ebay" />} />
          <Route path="/amazon/sales-breakdown" element={<SalesBreakdown vendor="amazon" />} />
          <Route path="/shopify/sales-breakdown" element={<SalesBreakdown vendor="shopify" />} />
          <Route path="/wholesale/sales-breakdown" element={<SalesBreakdown vendor="wholesale" />} />

          <Route path="/sales-by-region" element={<SalesByRegion />} />
          <Route path="/amazon/aov" element={<AOV vendor="amazon" />} />
          <Route path="/shopify/aov" element={<AOV vendor="shopify" />} />
          <Route path="/wholesale/aov" element={<AOV vendor="wholesale" />} />
          <Route path="/amazon/profit" element={<Profit vendor="amazon" />} />
          <Route path="/shopify/profit" element={<Profit vendor="shopify" />} />
          <Route path="/wholesale/profit" element={<Profit vendor="wholesale" />} />
          <Route path="/amazon/customer" element={<Customer vendor="amazon" />} />
          <Route path="/shopify/customer" element={<Customer vendor="shopify" />} />
          <Route path="/wholesale/customer" element={<WholesaleCustomer />} />
          <Route path="/amazon/order" element={<Order vendor="amazon" />} />
          <Route path="/shopify/order" element={<Order vendor="shopify" />} />
          <Route path="/wholesale/order" element={<WholesaleOrder />} />
          <Route path="/wholesale/revenue-customers" element={<RevenueFromCustomer vendor="wholesale" />} />
          <Route path="/amazon/subscribers/category" element={<SubscribersByCategory />} />
          <Route path="/amazon/monthly-order-subscription" element={<MonthlySubscription />} />
          <Route path="/amazon/revenue-from-subscription" element={<RevenueFromSubscription />} />
          <Route path="/amazon/promotion-by-revenue" element={<PromotionByRevenue />} />
          <Route path="/amazon/month-end-inventory" element={<MonthEndInventory />} />
          <Route path="/amazon/inventory-fba-forecast" element={<InventoryFBAForecast />} />
          <Route path="/amazon/adv-budget-performance" element={<AdvBudgetPerformance />} />
          <Route path="/amazon/adv-sales" element={<AdvSales />} />
          <Route path="/amazon/adv-products" element={<AdvProducts />} />
          <Route path="/amazon/adv-keywords" element={<AdvKeywords />} />
          <Route path="/amazon/adv-campaign" element={<AdvCampaign />} />
          <Route path="/amazon/subscribers" element={<Subscribers />} />
          <Route path="/notimplementedinfo" element={<ErrorPage />} />
          <Route path="/amazon/new-return-customer" element={<NewReturnCustomer vendor="amazon" />} />
          <Route path="/shopify/new-return-customer" element={<NewReturnCustomer vendor="shopify" />} />
          <Route path="/page/traffic/conversion" element={<PageTrafficWithConversion />} />
          <Route path="/amazon/repurchase/rate" element={<RepurchaseRate vendor="amazon" />} />
          <Route path="/shopify/repurchase/rate" element={<RepurchaseRate vendor="shopify" />} />
          <Route path="/amazon/basket/analysis" element={<BasketAnalysis vendor="amazon" />} />
          <Route path="/shopify/basket/analysis" element={<BasketAnalysis vendor="shopify" />} />
          <Route path="/amazon/lifetime-value" element={<LifeTimeValue vendor="amazon" />} />
          <Route path="/shopify/lifetime-value" element={<LifeTimeValue vendor="shopify" />} />
          <Route path="/korea/revenue" element={<KoreaRevenue />} />
          <Route path="/korea/revenue-customer" element={<KoreaRevenueByCustomer />} />

          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/amazon/reports/best-times" element={<BestTimes vendor="amazon" />} />
          <Route path="/shopify/reports/best-times" element={<BestTimes vendor="shopify" />} />
          <Route path="/upload/product" element={<UploadProduct />} />
          <Route path="/upload/order" element={<UploadOrder />} />
          <Route path="/pos/sales" element={<Sales />} />
          <Route path="/pos/sales-by-product" element={<SalesByProduct />} />
          <Route path="/pos/upload" element={<POSExcelImport />} />
          <Route path="/pos/details" element={<POSDetail />} />
          <Route path="/pos/sales-breakdown-by-product" element={<SalesBreakdownByProduct />} />
          <Route path="/query" element={<Query />} />

          <Route path="/session/by/referrer" element={<SessionByRefferer />} />
          <Route path="/sales/by/referrer" element={<SalesByRefferer />} />
          <Route path="/sales/by/channel" element={<SalesByChannel />} />
          <Route path="/amazon/reports/VirtualBundleSales" element={<VirtualBundleSales />} />
          <Route path="/virtualbundlesales/upload" element={<UploadVirtualBundleSalesExcel />} />
          <Route path="/virtualbundlesales/details" element={<VirtualBundleSalesUploadDetails />} />
          <Route path="/amazon/Promotion-prime" element={<Promotion />} />
          <Route path="/amazon/Customer-Transition" element={<CustomerTransition />} />
          <Route path="/data-ingestion-batch-status" element={<DataIngestionBatchStatus />} />
          <Route path="/report/searchPositionTracker/detail" element={<SearchPositionTracker />} />
          <Route path="/report/searchPositionTracker/upload" element={<UploadSearchPositionTracker />} />
          <Route path="/upload/fullfillment/shipment" element={<FullfillmentShipment />} />
          <Route path="/performance/by/sku" element={<PerformanceBySKU />} />
          <Route path="/return-refund" element={<ReturnRefund />} />
          <Route path="/amazon/tax" element={<Tax />} />
          <Route path="/upload/subscriber" element={<UploadSubscriberExcel />} />

          <Route path="/app_dashboard" element={<AppDashboard />} />
          <Route path="/booking_dashboard" element={<BookingDashboard />} />
          <Route path="/finance_dashboard" element={<Finance />} />
          <Route path="/fitness_dashboard" element={<FitnessDashboard />} />
          <Route path="/ui" element={<UI />} />
          <Route path="/mail" element={<Mail />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/todo" element={<Todo />} />
          <Route path="/forms" element={<Forms />} />
          <Route path="/tables" element={<Tables />} />
          <Route path="/charts" element={<Charts />} />
          <Route path="/maps" element={<Maps />} />
          <Route path="/account" element={<Account />} />
          <Route path="/e-commerce" element={<ECommerce />} />
          <Route path="/default_pages" element={<DefaultPages />} />
          <Route path="/documentation" element={<Documentation />} />
        </Routes>
      </div>
    </div>
  );

}
